import { Component, OnInit } from '@angular/core';
import { UserDetailsService } from 'src/app/services/user-details.service';

@Component({
  selector: 'app-bug-module',
  templateUrl: './bug-module.component.html',
  styleUrls: ['./bug-module.component.scss']
})
export class BugModuleComponent implements OnInit {
  hasDeveloperRights:boolean;
  constructor(public userDetailService: UserDetailsService) { }

  ngOnInit(): void {
    this.hasDeveloperRights=this.userDetailService.hasRole([
      'ROLE_PULSE_MANAGER',
      'ROLE_PULSE_DEVELOPER'
    ]);
  }

}
